module.exports = __webpack_public_path__ + "static/brv5-final-desktop-mockup.18eec238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/brv5-final-desktop-mockup.jpg
// module id = ./src/pages/brv5-final-desktop-mockup.jpg
// module chunks = 19913542803863